const GET_COMPANY_AGREEMENT_START = 'GET_COMPANY_AGREEMENT_START';
const GET_COMPANY_AGREEMENT_SUCCESS = 'GET_COMPANY_AGREEMENT_SUCCESS';
const GET_COMPANY_AGREEMENT_ERROR = 'GET_COMPANY_AGREEMENT_ERROR';

const getCompanyAgreementStart = () => {
	return {
		type: GET_COMPANY_AGREEMENT_START
	};
};
const getCompanyAgreementSuccess = (res) => {
	return {
		type: GET_COMPANY_AGREEMENT_SUCCESS,
		res
	};
};
const getCompanyAgreementError = () => {
	return {
		type: GET_COMPANY_AGREEMENT_ERROR,
	};
};

export default {
	types: {
		GET_COMPANY_AGREEMENT_START,
		GET_COMPANY_AGREEMENT_SUCCESS,
		GET_COMPANY_AGREEMENT_ERROR,
	},
	creators: {
		getCompanyAgreementStart,
		getCompanyAgreementSuccess,
		getCompanyAgreementError,
	},
};
